import VisuallyHidden from '@reach/visually-hidden';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '../Typography';
import { Compensation, Industry, JobType, Schedule } from './icons';
import { ShiftHourRange } from './ShiftHourRange';
import { useStyles } from './styles';

export interface ReachLabelsProps {
  payRate?: string;
  minWeeklyHours?: number;
  maxWeeklyHours?: number;
  jobHours?: string;
  jobType?: string;
  industry?: string;
  showCompensation: boolean;
}

export const ReachLabels: FC<ReachLabelsProps> = ({
  payRate,
  minWeeklyHours,
  maxWeeklyHours,
  jobHours,
  jobType,
  industry,
  showCompensation = true,
}) => {
  const classes = useStyles();

  // Converts "part_time" to "Part-time"
  const parseCapsuleContent = (text: string) => {
    const words = text.split('_');
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    return words.join(' ');
  };

  const displayPayRate = showCompensation && payRate;

  if (
    !displayPayRate &&
    !jobHours &&
    !jobType &&
    !industry &&
    !(minWeeklyHours && maxWeeklyHours)
  ) {
    return null;
  }

  return (
    <div className={classes.capsulesWrapper}>
      {displayPayRate && (
        <div className={classes.capsule}>
          <VisuallyHidden>
            <FormattedMessage
              defaultMessage="Compensation"
              description="Accessibility label for screen readers describing Compensation icon"
            />
          </VisuallyHidden>
          <Compensation className={classes.capsuleIcon} />
          <Typography variant="subtitle">{payRate}</Typography>
        </div>
      )}
      {jobHours && (
        <div className={classes.capsule}>
          <VisuallyHidden>
            <FormattedMessage
              defaultMessage="Schedule"
              description="Accessibility label for screen readers describing Schedule icon"
            />
          </VisuallyHidden>
          <Schedule className={classes.capsuleIcon} />
          <Typography variant="subtitle">
            {parseCapsuleContent(jobHours)}
          </Typography>
        </div>
      )}
      {jobType && (
        <div className={classes.capsule}>
          <VisuallyHidden>
            <FormattedMessage
              defaultMessage="Job Type"
              description="Accessibility label for screen readers describing Job type icon"
            />
          </VisuallyHidden>
          <JobType className={classes.capsuleIcon} />
          <Typography variant="subtitle">
            {parseCapsuleContent(jobType)}
          </Typography>
        </div>
      )}
      {industry && (
        <div className={classes.capsule}>
          <VisuallyHidden>
            <FormattedMessage
              defaultMessage="Industry"
              description="Accessibility label for screen readers describing Industry icon"
            />
          </VisuallyHidden>
          <Industry className={classes.capsuleIcon} />
          <Typography variant="subtitle">
            {parseCapsuleContent(industry)}
          </Typography>
        </div>
      )}
      <ShiftHourRange
        minWeeklyHours={minWeeklyHours}
        maxWeeklyHours={maxWeeklyHours}
        styles={{ root: classes.innerText, icon: classes.icons }}
      />
    </div>
  );
};
